<template>
  <HelloWorld />
</template>

<script>
import { defineComponent } from 'vue';

// Components
import HelloWorld from '../components/HelloWorld.vue';

export default defineComponent({
  name: 'HomeView',

  components: {
    HelloWorld,
  },
});
</script>
<style>
html, body{
  height: 100%;
  background-color:#000;
}
body{
  margin: 0;
  padding: 0;
  background-color:#000;
}

.appColorBack{
  background-color: #000;
}
</style>
